import { Controller } from "@hotwired/stimulus"

// Export Modal Controller - handles opening/closing modals
// Usage: Add data-controller="export-modal" to a container
//        Add data-action="click->export-modal#open" to buttons
//        Add data-modal-id="your-modal-id" to specify which modal to open
export default class extends Controller {
  connect() {
    console.log("Export modal controller connected")
  }

  open(event) {
    event.preventDefault()
    // Get modal ID from the clicked element's data attribute or default
    const modalId = event.currentTarget.dataset.modalId || "export-modal"
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.remove("hidden")
      modal.focus()
      document.body.style.overflow = "hidden"
    }
  }

  close(event) {
    if (event) event.preventDefault()
    const modalId = event.currentTarget.dataset.modalId || this.element.querySelector("[data-modal-id]")?.dataset.modalId || "export-modal"
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }
}
